import { useEffect, useState } from "react";

export function useSliderValue({ value, setDetails, length, max }) {
	const maxCount = Math.min(length, max);
	const [localValue, setLocalValue] = useState(value);

	useEffect(() => {
		const timer = setTimeout(() => {
			if (value !== localValue) {
				setDetails(localValue);
			}
		}, 500);
		return () => clearTimeout(timer);
	}, [localValue, setDetails, value]);

	useEffect(() => {
		if (value !== localValue) {
			setLocalValue(value);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [value]);

	useEffect(() => {
		if (length < localValue) {
			setLocalValue(length);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [length]);

	return {
		value: localValue,
		setValue: (value) => {
			setLocalValue(value);
		},
		maxCount,
	};
}
